export const NICLAnalyticsColumn = [
  // registered_number - Newly registered number
  {
    Header: "Mobile number",
    accessor: "registered_number",
  },
  // customer_name
  {
    Header: "Customer Name",
    accessor: "customer_name",
  },
  // Workflow name
  {
    Header: "Workflow",
    accessor: "workflowName",
  },
  // Duration
  {
    Header: "Call duration",
    accessor: "callDuration",
  },
  // Recording
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  // Time stamp
  {
    Header: "Time Stamp",
    accessor: "response_time",
  },
  // policy_number
  {
    Header: "Policy Number",
    accessor: "policy_number",
  },
  // ptp_date - Policy Expiration Date
  {
    Header: "Policy Expiration Date",
    accessor: "ptp_date",
  },
  // due_amount - Renewal Amount
  {
    Header: "Renewal Amount",
    accessor: "due_amount",
  },
  // vehicle_registration_number
  {
    Header: "Vehicle registration number",
    accessor: "vehicle_registration_number",
  },
  // product_name
  {
    Header: "Product Name",
    accessor: "product_name",
  },

  // delay_reason - Reason why the customer is not renewing the policy
  {
    Header: "Delay Reason",
    accessor: "delay_reason",
  },
  // update_info_convey - True/False
  {
    Header: "Update Info Convey",
    accessor: "update_info_convey",
  },

  // downloaded_pdf - True/False
  {
    Header: "Downloaded Pdf",
    accessor: "downloaded_pdf",
  },

  // call_transfer - Transferred call to live agent or not
  {
    Header: "Call transfer",
    accessor: "call_transfer",
  },

  // send_sms - We will send SMS or not (True/False)
  {
    Header: "Send sms",
    accessor: "send_sms",
  },

  // sms_content - Decide content of text message
  {
    Header: "Sms content",
    accessor: "sms_content",
  },
];

export const wfNameAndIdmapping = [
  // {
  //   name: "Zet Scenario Id 1 (P0001)",
  //   id: "P0001",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Zet Scenario Id 2 (P0002)",
  //   id: "P0002",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Retargeting (P0003)",
  //   id: "P0003",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week (P0004)",
  //   id: "P0004",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Month (P0005)",
  //   id: "P0005",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Improve Credit Score Consent (P0006)",
  //   id: "P0006",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Soft Churn and Hard Churn Agent: Brand Re-activation (P0007)",
  //   id: "P0007",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Soft Churn and Hard Churn Agent: New Brand (P0008)",
  //   id: "P0008",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Soft Churn and Hard Churn Agent: Approval Rate (P0009)",
  //   id: "P0009",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week New (P00010)",
  //   id: "P00010",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week: Round 2 (P00011)",
  //   id: "P00011",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week: FOMO (P00012)",
  //   id: "P00012",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Priority Agent (P00013)",
  //   id: "P00013",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Sales: End Customer (P00014)",
  //   id: "P00014",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "AU Activation Customer (P00015)",
  //   id: "P00015",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "HSBC Activation Customer (P00016)",
  //   id: "P00016",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "HDFC Activation Customer (P00017)",
  //   id: "P00017",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet customer to customer referral (P00018)",
  //   id: "P00018",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week : Intro July (P00019)",
  //   id: "P00019",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week : FOMO July (P00020)",
  //   id: "P00020",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Week Offer : Extension July (P00021)",
  //   id: "P00021",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "New Categories on ZET Partner (P00022)",
  //   id: "P00022",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Sales Bonus ZET Partner (P00023)",
  //   id: "P00023",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "ZET Partner Referral Championship Program (P00024)",
  //   id: "P00024",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Credit Mahotsav ZET Partner (P00025)",
  //   id: "P00025",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Credit Mahotsav ZET Partner Second (P00026)",
  //   id: "P00026",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Saving Dhamaka Offer FOMO (P00027)",
  //   id: "P00027",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Magnet Bonanza Week (P00028)",
  //   id: "P00028",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Loan Mahotsav (P00029)",
  //   id: "P00029",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },

  // {
  //   name: "ZET Partner Magnet New Year Sale(P00030)",
  //   id: "P00030",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Bharti AXA ( Pre due ) (P00031)",
  //   id: "P00031",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },

  {
    name: "Zet",
    id: "Zet",
    templateUrl:
      "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  },
  //   {
  //   name: "Edelweiss (P00033)",
  //   id: "P00033",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  //    {
  //   name: "India First (P00034)",
  //   id: "P00034",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  // {
  //   name: "Edelweiss Version 2(P00034)",
  //   id: "P00034",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  //  {
  //   name: "IndiaFirst Post Due (P00035)",
  //   id: "P00035",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
  //    {
  //   name:  "IndiaFirst Pre Due (P00036)",
  //   id: "P00036",
  //   templateUrl:
  //     "https://sachatbotdev01.blob.core.windows.net/nicl-automated-user-list/Workflow_Template_NICL_V2.0.csv",
  // },
];

export const policyRenewalColumn = [
  //Phone Number
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  //Session Id
  {
    Header: "Session Id",
    accessor: "sessionId",
  },
  // customer_name
  {
    Header: "Customer Name",
    accessor: "customerName",
  },
  // policy_number
  // {
  //   Header: "Policy Number",
  //   accessor: "policy_number",
  // },
  // due_amount - Renewal Amount
  // {
  //   Header: "Renewal Amount",
  //   accessor: "due_amount",
  // },
  // ptp_date - Policy Expiration Date
  // {
  //   Header: "Policy Expiration Date",
  //   accessor: "ptp_date",
  // },
  // {
  //   Header: "Renew Policy",
  //   accessor: "renew_policy",
  // },
  // product_name
  {
    Header: "Product Name",
    accessor: "productName",
  },
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "Bank Name",
    accessor: "bankName",
  },
  {
    Header: "Agent Name",
    accessor: "agentName",
  },
  {
    Header: "Applying Card",
    accessor: "applyingCard",
  },
  // delay_reason - Reason why the customer is not renewing the policy
  // {
  //   Header: "Delay Reason",
  //   accessor: "delay_reason",
  // },
  // vehicle_registration_number
  // {
  //   Header: "Vehicle reg no",
  //   accessor: "vehicle_registration_number",
  // },
  // send_sms - We will send SMS or not (True/False)
  {
    Header: "Send sms",
    accessor: "sendSms",
  },
  // call_transfer - Transferred call to live agent or not
  {
    Header: "Call transfer",
    accessor: "call_transfer",
  },
  // Duration
  {
    Header: "Call duration",
    accessor: "callDuration",
  },
  // Recording
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  // Time stamp
  {
    Header: "Time Stamp",
    accessor: "response_time",
  },
];

export const healthInsuranceColumn = [
  //Phone Number
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  //Session Id
  {
    Header: "Session Id",
    accessor: "sessionId",
  },
  // customer_name
  {
    Header: "Customer Name",
    accessor: "customerName",
  },
  // policy_number
  // {
  //   Header: "Policy Number",
  //   accessor: "policy_number",
  // },
  // due_amount - Renewal Amount
  // {
  //   Header: "Renewal Amount",
  //   accessor: "due_amount",
  // },
  // ptp_date - Policy Expiration Date
  // {
  //   Header: "Policy Expiration Date",
  //   accessor: "ptp_date",
  // },
  // {
  //   Header: "Renew Policy",
  //   accessor: "renew_policy",
  // },
  // product_name
  {
    Header: "Product Name",
    accessor: "productName",
  },
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "Bank Name",
    accessor: "bankName",
  },
  {
    Header: "Agent Name",
    accessor: "agentName",
  },
  {
    Header: "Applying Card",
    accessor: "applyingCard",
  },
  // delay_reason - Reason why the customer is not renewing the policy
  // {
  //   Header: "Delay Reason",
  //   accessor: "delay_reason",
  // },
  // vehicle_registration_number
  // {
  //   Header: "Vehicle reg no",
  //   accessor: "vehicle_registration_number",
  // },
  // send_sms - We will send SMS or not (True/False)
  {
    Header: "Send sms",
    accessor: "sendSms",
  },
  // call_transfer - Transferred call to live agent or not
  {
    Header: "Call transfer",
    accessor: "call_transfer",
  },
  // Duration
  {
    Header: "Call duration",
    accessor: "callDuration",
  },
  // Recording
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  // Time stamp
  {
    Header: "Time Stamp",
    accessor: "response_time",
  },
];

export const policyPDFDownloadColumn = [
  //Phone Number
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  // customer_name
  {
    Header: "Customer Name",
    accessor: "customer_name",
  },
  // policy_number
  {
    Header: "Policy Number",
    accessor: "policy_number",
  },
  // update_info_convey - True/False
  {
    Header: "Policy availability",
    accessor: "policy_number_availability",
  },

  // product_name
  {
    Header: "Product Name",
    accessor: "product_name",
  },
  // due_amount - Renewal Amount
  {
    Header: "Renewal Amount",
    accessor: "due_amount",
  },
  // ptp_date - Policy Expiration Date
  {
    Header: "Policy Expiration Date",
    accessor: "ptp_date",
  },
  // send_sms - We will send SMS or not (True/False)
  {
    Header: "Send sms",
    accessor: "send_sms",
  },
  // downloaded_pdf - True/False
  {
    Header: "Downloaded Pdf",
    accessor: "downloaded_pdf",
  },
  // call_transfer - Transferred call to live agent or not
  {
    Header: "Call transfer",
    accessor: "call_transfer",
  },
  // Recording
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  // Duration
  {
    Header: "Call duration",
    accessor: "callDuration",
  },

  // Time stamp
  {
    Header: "Time Stamp",
    accessor: "response_time",
  },
];

export const mobileNumberRegistrationColumn = [
  //Phone Number
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  // customer_name
  {
    Header: "Customer Name",
    accessor: "customer_name",
  },
  // registered_number
  {
    Header: "Registered Number",
    accessor: "registered_number",
  },
  // policy_number
  {
    Header: "Policy Number",
    accessor: "policy_number",
  },

  // product_name
  {
    Header: "Product Name",
    accessor: "product_name",
  },
  // due_amount - Renewal Amount
  {
    Header: "Renewal Amount",
    accessor: "due_amount",
  },
  // ptp_date - Policy Expiration Date
  {
    Header: "Policy Expiration Date",
    accessor: "ptp_date",
  },
  // send_sms - We will send SMS or not (True/False)
  {
    Header: "Send sms",
    accessor: "send_sms",
  },
  // update_info_convey - True/False
  {
    Header: "Policy availability",
    accessor: "policy_number_availability",
  },
  // call_transfer - Transferred call to live agent or not
  {
    Header: "Call transfer",
    accessor: "call_transfer",
  },
  // Recording
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  // Duration
  {
    Header: "Call duration",
    accessor: "callDuration",
  },

  // Time stamp
  {
    Header: "Time Stamp",
    accessor: "response_time",
  },
];

export const INCCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Disposition ID",
    accessor: "dispositionId",
  },
  {
    Header: "Promised Pay Date",
    accessor: "ppDate",
  },
  {
    Header: "Due Amount",
    accessor: "dueAmount",
  },
  {
    Header: "Promised Pay Amount",
    accessor: "ppAmount",
  },
  {
    Header: "Delay Reason",
    accessor: "delayReason",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];
export const MorningCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Region",
    accessor: "region",
  },
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "On Leave?",
    accessor: "workingToday",
  },
  {
    Header: "# Shops To Visit",
    accessor: "totalRetailShop",
  },
  {
    Header: "Markets To Visit",
    accessor: "shopsToBeVisited",
  },
  {
    Header: "Focused product",
    accessor: "focusedProduct",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];

export const EveningCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Person Name",
    accessor: "personName",
  },
  {
    Header: "Region",
    accessor: "region",
  },
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "On Leave?",
    accessor: "workingToday",
  },
  {
    Header: "Office Meeting",
    accessor: "officeMeeting",
  },
  {
    Header: "Calls made today",
    accessor: "callsMadeToday",
  },
  {
    Header: "Productive Calls",
    accessor: "productiveCalls",
  },
  {
    Header: "Productivity",
    accessor: "productivity",
  },
  {
    Header: "Sell Value for today",
    accessor: "sellValueForToday",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];

export const columnsDataCheck = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const UnansweredCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  //Session Id
  {
    Header: "Session Id",
    accessor: "sessionId",
  },
  // {
  //   Header: "Person Name",
  //   accessor: "personName",
  // },
  // {
  //   Header: "Product Name",
  //   accessor: "productName",
  // },
  // {
  //   Header: "Bank Name",
  //   accessor: "bankName",
  // },
  // {
  //   Header: "Agent Name",
  //   accessor: "agentName",
  // },
  // {
  //   Header: "Language",
  //   accessor: "language",
  // },

  {
    Header: "Attempts",
    accessor: "numberOfAttempts",
  },
  {
    Header: "Call Status",
    accessor: "callStatus",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];

export const IPACCallTableColumns = [
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Party Selected",
    accessor: "partyName",
  },
  {
    Header: "Rating current Govt.",
    accessor: "ratingCurrentGov",
  },
  {
    Header: "Vote current Govt.?",
    accessor: "voteCurrentGov",
  },
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Call Duration",
    accessor: "callDuration",
  },
  {
    Header: "Timestamp",
    accessor: "timestamp",
  },
];

export const flow32BhartiAXA = [
  //Phone Number
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  //Session Id
  {
    Header: "Session Id",
    accessor: "sessionId",
  },
  {
    Header: "Call info",
    accessor: "callInfo",
  },
  {
    Header: "Issue Resolved",
    accessor: "issueResolved",
  },

  {
    Header: "Call transfer",
    accessor: "call_transfer",
  },
  {
    Header: "Incomplete call ?",
    accessor: "callNotComplete",
  },
  {
    Header: "Call Abandoned",
    accessor: "callAbandoned",
  },
  {
    Header: "CSAT Rating",
    accessor: "csatRating",
  },

  // Duration
  {
    Header: "Call duration",
    accessor: "callDuration",
  },
  // Recording
  {
    Header: "Call Recording",
    accessor: "callRecording",
  },
  {
    Header: "Customer Queries",
    accessor: "customerQueries",
  },
  {
    Header: "L1 Sub Query",
    accessor: "l1SubQuery",
  },
  {
    Header: "L2 Sub Query",
    accessor: "l2SubQuery",
  },
  {
    Header: "L3 Sub Query",
    accessor: "l3SubQuery",
  },
  //Phone Number

  //Session Id
  // {
  //   Header: "# Conv. Completed ?",
  //   accessor: "conversationCompleted",
  // },

  // {
  //   Header: "Gender",
  //   accessor: "gender",
  // },

  {
    Header: "Call-back by",
    accessor: "callBackArrangedBy",
  },
  {
    Header: "Call-back type",
    accessor: "callBackType",
  },
  {
    Header: "Call Type",
    accessor: "callType",
  },

  {
    Header: "Language",
    accessor: "language",
  },
  // {
  //   Header: "Bank Name",
  //   accessor: "bankName",
  // },
  // // {
  // //   Header: "Agent Name",
  // //   accessor: "agentName",
  // // },
  // // {
  // //   Header: "Applying Card",
  // //   accessor: "applyingCard",
  // // },
  // {
  //   Header: "Insured Person Name",
  //   accessor: "customerInsuredPersonName",
  // },
  // {
  //   Header: "Nominee Name",
  //   accessor: "customerNomineeName",
  // },
  // {
  //   Header: "Insurance Company",
  //   accessor: "customerInsuranceCompany",
  // },
  // {
  //   Header: "Plan Name",
  //   accessor: "customerPlanName",
  // },
  // {
  //   Header: "Late Fee",
  //   accessor: "customerLateFee",
  // },
  // {
  //   Header: "Current Fund/Surrender Value",
  //   accessor: "customerCurrentFundSurrenderValue",
  // },
  // {
  //   Header: "Death Cover (Original)",
  //   accessor: "customerDeathCoverOriginal",
  // },
  // {
  //   Header: "Death Cover (Reduced)",
  //   accessor: "customerDeathCoverReduced",
  // },
  // {
  //   Header: "Loan Amount",
  //   accessor: "customerLoanAmount",
  // },
  // {
  //   Header: "Interest Rate",
  //   accessor: "customerInterestRate",
  // },
  // {
  //   Header: "Mode Change Amount",
  //   accessor: "customerModeChangeAmount",
  // },
  // {
  //   Header: "Actual Mode",
  //   accessor: "customerActualMode",
  // },
  // {
  //   Header: "New Mode",
  //   accessor: "customerNewMode",
  // },
  // {
  //   Header: "Assignment Value",
  //   accessor: "customerAssignmentValue",
  // },
  // {
  //   Header: "Policy Status",
  //   accessor: "customerPolicyStatus",
  // },
  // {
  //   Header: "Annual Premium",
  //   accessor: "customerAnnualPremium",
  // },
  // {
  //   Header: "Give Value",
  //   accessor: "customerGiveValue",
  // },
  // {
  //   Header: "Get Value",
  //   accessor: "customerGetValue",
  // },
  // {
  //   Header: "Issue date",
  //   accessor: "customerIssuedDate",
  // },
  // {
  //   Header: "Late Payment Charges Interest Rate",
  //   accessor: "customerLatePaymentChargesInterestRate",
  // },
  // {
  //   Header: "Send sms",
  //   accessor: "sendSms",
  // },
  // call_transfer - Transferred call to live agent or not

  // Time stamp
  {
    Header: "Time Stamp",
    accessor: "response_time",
  },
];
